import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, ViewChild, Output, Input, OnChanges, SimpleChange, SimpleChanges, TemplateRef, ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { DialogService, WindowService, DialogRef, DialogCloseResult, WindowRef } from '@progress/kendo-angular-dialog';
import { DataStateChangeEvent, GridDataResult, RowClassArgs, FilterService, SinglePopupService, PopupCloseEvent, GridComponent } from '@progress/kendo-angular-grid';
import { State, process, SortDescriptor, CompositeFilterDescriptor, FilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { addDays, getDate } from '@progress/kendo-date-math';
import { BehaviorSubject, Subscription, Observable, from, of, interval, combineLatest, forkJoin, lastValueFrom, firstValueFrom } from 'rxjs';
import { FlowTagsComponent } from '../flow-tags/flow-tags.component';
import { FlowManagementService, distinct, flatten, groupBy } from '../services/flow-management.service';
// import { StorageService } from '../services/storage.service';
import { UserItem } from '../services/storage-types';
import { StorageRouterService } from '../services/storage-router.service';
import { ENV_SCAN_STALE_MS } from '../services/env-scan.util';
import { Flow, getRunColour } from '../obj/Flow';
import { FlowRun } from '../obj/FlowRun'
import { FlowDetailComponent } from './flow.detail.component';
import { Settings } from './settings';
import { DomSanitizer, SafeStyle, SafeUrl } from '@angular/platform-browser';
import { FlowRenameComponent } from './flow-rename.component';
//import { AnalyticsService } from '../services/analytics.service';
import { colours } from '../../app/constants';
import { FlowEventService, FlowEvent } from '../services/flow-event.service';
import { filter, count, map, switchMap, distinctUntilChanged, debounceTime, mergeMap, timeInterval, first, flatMap } from 'rxjs/operators';
import { PaymentService } from '../services/payment.service';
import { FlowVersionsComponent } from '../flow-versions/flow-versions.component';
import { FlowSolutionComponent } from '../flow-solution/flow-solution.component';
import { Connection } from '../obj/Connection';
import { ApplicationInsightsService } from '../services/application-insights.service';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { FlowDiagramComponent } from '../flow-diagram/flow-diagram.component';
//import { query, setQueryConfig, refreshQuery } from 'rx-query';
import { FlowBaseComponent } from './flow-base.component';
import { HttpCancelService } from '../services/http-cancel.service';
import { FlowEditorComponent } from './flow.editor.component';
import { DetailsComponent } from '../teams/details.component';
import { adminTrace } from '../services/debug-host.util';
import { ApiService } from '../services/api.service';
import { MsalHelperService } from '../services/msal-helper.service';
import { ButtonFillMode } from '@progress/kendo-angular-buttons';
import { BrowserCacheCoordinationService } from '../services/browser-cache-coordination.service';
//import mermaid from 'mermaid'

@Component({
    selector: 'app-flows',
    templateUrl: './flows.component.html',
    styleUrls: ['./flows.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class FlowsComponent extends FlowBaseComponent implements OnInit, OnChanges {

    //environment: string;
    environment$: BehaviorSubject<string> = new BehaviorSubject(null);
    apiRoot: string = "https://flow.microsoft.com";
    flowsLoading$: BehaviorSubject<number> = new BehaviorSubject(0);
    flowTags: string[] = [];
    flowActions: string[] = [];
    flowTriggers: string[] = [];
    flowTriggerKinds: string[] = [];
    flowStates: string[] = [];
    allOwners = new BehaviorSubject([]);
    events: FlowRun[] = [];
    state: State = {
        skip: 0,
        take: 100, //this.flows.length,

        // Initial filter descriptor
        group: [],
        filter: {
            logic: 'and',
            filters: [] //[{ field: 'ProductName', operator: 'contains', value: 'Chef' }]
        },
        sort: [
            {
                'field': 'displayName',
                'dir': 'asc'
            }
        ]
    };
    state$: BehaviorSubject<State> = new BehaviorSubject(this.state);
    private scanLeaseGeneration: number | null = null;
    view$: Observable<GridDataResult>;
    loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    cache = {
        flows: 0,
        runs: 0,
        settings: 0
    };

    // public multiselect = false;
    loaded: boolean = false;
    fillMode: ButtonFillMode = "solid";

    /** Incremented on every refreshEnvironment call so stale promise chains can self-abort. */
    private _scanGeneration = 0;

    @ViewChild('grid', {static: false}) grid: GridComponent;
    @ViewChild('multiConfirm') multiConfirmTemplate: TemplateRef<any>;
    @ViewChild('deleteConfirm') deleteConfirmTemplate!: TemplateRef<any>;
    public deleteConfirmInput: string = '';
    public deleteConfirmExpected: string = '';
    @Input() public display: string = '';

    public fieldRuns = true;
    public fieldSelectable = true;
    public fieldSelectableMulti = false;
    @Input()
    public fieldIncludeSolution = false;
    @Input()
    public fieldIsAdmin = false;
    token_flow = null;
    token_flow_a = null;
    public gridHeight = "100%";

    public licenseHasTeams = false;

    public visibleColumns: Set<string> = new Set([
        'shareOwners','displayName','monitor','runsColorBar','tags','trigger',
        'triggerKind','flowState','modified','runsSort','runsFailCount','lastRun'
    ]);
    public visibleDeprecatedTools: Set<string> = new Set(['powerApps','approvals','httpRequest']);
    public visibleFlowLinks: Set<string> = new Set(['v2','v3','v4']);

    isColVisible(key: string): boolean { return this.visibleColumns.has(key); }
    isToolVisible(key: string): boolean { return this.visibleDeprecatedTools.has(key); }
    isFlowLinkVisible(key: string): boolean { return this.visibleFlowLinks.has(key); }

    private connections : Connection[] = [];

    private subscriptions = new Subscription();
    public search$ = new BehaviorSubject('');
    public params$ = new BehaviorSubject<Params>(null);
    //public scrollable$ = new BehaviorSubject<"scrollable"|"virtual">("scrollable");
    public debug = window.location.host.startsWith('localhost');

    public items: string[] = []
    public buttonCount = 0;

    constructor(
        private route: ActivatedRoute,
        // private storageService: StorageService,
        private storageDexieService: StorageRouterService,
        public flowManagementService: FlowManagementService,
        private msalHelperService: MsalHelperService,
        private monitorService: ApiService,
        protected flowEventService: FlowEventService,
        router: Router,
        private windowService: WindowService,
        private dialogService: DialogService,
        protected sanitizer: DomSanitizer,
        //private analytics: AnalyticsService,
        private appInsights: ApplicationInsightsService,
        protected paymentService: PaymentService,
        private httpCancelService: HttpCancelService,
        private cdr: ChangeDetectorRef,
        private browserCacheCoordination: BrowserCacheCoordinationService,
        // private popupService: SinglePopupService
    ) {

        super(flowManagementService, flowEventService, paymentService, sanitizer, router);

        this.token_flow = this.msalHelperService.getCachedTokenInternal(['https://service.flow.microsoft.com//Flows.Manage.All']);
        this.token_flow_a = this.msalHelperService.getCachedTokenInternal(['https://service.powerapps.com/User']);
    
        this.subscriptions.add(this.route.queryParams.subscribe((params)=>{
          this.params$.next(params);
        }));

        this.subscriptions.add(route.data.subscribe(({fieldIncludeSolution})=>{
          this.fieldIncludeSolution = !!fieldIncludeSolution;
        }));
        this.subscriptions.add(route.data.subscribe(({fieldIsAdmin})=>{
          this.fieldIsAdmin = !!fieldIsAdmin;
          this.gridHeight = "100%";
        }));
        this.subscriptions.add(this.paymentService.licenseHasTeams$.subscribe((teams)=>{
          this.licenseHasTeams = teams;
        }));

        const getFlows = route.data.pipe(switchMap(({fieldIsAdmin})=>{
            return fieldIsAdmin ? this.storageDexieService.getFlowsAdmin$() : this.storageDexieService.getFlows$();
        }));

        //const getFlowsFromServer = 
        /*
        setQueryConfig({
            keepPreviousData: true,
            staleTime: 1000*60*60,
            cacheTime: 1000*60*60
        });
        */

        /*
        this.flowEventService.flowsUpdated$.pipe(map((updated)=>{
          if (updated && this.environment) {
            this.loadFlowsFromStorage(this.environment);
          }
        }));
        */

        // this.subscriptions.add(this.flowManagementService.flows$.subscribe((flows)=>{
        //   const flows1 = flows.filter((f)=>f.environment == this.environment);
        //   this.flows$.next(flows1);
        // }));

        this.subscriptions.add(
            combineLatest([this.flowManagementService.currentEnvironment$, getFlows])
            .subscribe(([environment, flows])=>{
                // [admin-trace] Log EVERY emission, even when env is empty —
                // we need to know whether the observable is firing at all and
                // what the source observable is delivering.
                const fromAdmin = this.fieldIsAdmin;
                const incomingLen = flows?.length ?? 0;
                const sample = (flows || []).slice(0, 3).map((f: any) => ({
                    flowName: f?.flowName,
                    environment: f?.environment,
                    sources: f?.sources,
                }));
                if (!environment || environment == '') {
                    adminTrace(`[admin-trace] flows$-feed env=EMPTY fieldIsAdmin=${fromAdmin} incoming=${incomingLen} sample=${JSON.stringify(sample)}`);
                    this.flows$.next([]);
                    return;
                }
                const _flows = flows.filter(flow=>flow.environment == environment);
                adminTrace(`[admin-trace] flows$-feed env=${JSON.stringify(environment)} fieldIsAdmin=${fromAdmin} incoming=${incomingLen} envMatched=${_flows.length} sample=${JSON.stringify(sample)}`);
                this.flows$.next(_flows);

                this.flowEventService.flowsUpdated$.next(true);
            })
        );

        this.subscriptions.add(
            combineLatest([this.flowManagementService.currentEnvironment$, this.storageDexieService.getRuns$()])
            .subscribe(([environment, runs])=>{
                const _runs = runs.filter(run=>run.environment == environment);
                this.runs$.next(_runs);    
            })
        );

        this.subscriptions.add(this.storageDexieService.getUsers$().subscribe((users)=>{
            this.users$.next(users);
        }));

        // Header buttons (app.component) bridge through flow-event service.
        this.subscriptions.add(this.flowEventService.manualRefresh$.subscribe(() => {
            const env = this.environment$.value;
            if (env) this.refreshEnvironment(env, true);
        }));
        this.subscriptions.add(this.flowEventService.cancelScan$.subscribe(() => {
            this.cancel();
        }));

        // this.subscriptions.add(this.search$.subscribe((search)=>{

        //     let filter_d = null;
        //     try {
        //         filter_d = Date.parse(search)
        //     }
        //     catch {

        //     }

        //     let filter: CompositeFilterDescriptor = {
        //         "logic": "or",
        //         "filters": [
        //         ],
        //     };
        //     if (search) {
        //         filter.filters.push(...[
        //             { "field": "displayName", "operator": "contains", "value": `${search}` },
        //             { "field": "tags", "operator": "contains", "value": `${search}` },
        //             { "field": "trigger", "operator": "contains", "value": `${search}` },
        //             { "field": "triggerKind", "operator": "contains", "value": `${search}` },
        //         ]);
        //     }
        //     if (filter_d) {
        //         filter.filters.push(...[
        //             { "field": "modified", "operator": "gte", "value": `${filter_d}` },
        //             { "field": "lastRun", "operator": "gte", "value": `${filter_d}` },
        //         ]);
        //     }


        //     let state = this.state$.value;

        //     this.state$.next({
        //         ...state,
        //         filter
        //     })

        // }));

        const getOwners = (flowOwners:string[], users: UserItem[]): any[] =>{
            return (flowOwners || []).map((id)=>{

                const u = (users || []).find(user => user.key.endsWith(id));
                return u ? { 'text': u.displayName, 'value': id } : { 'text': id, 'value': id };
            })
        };

        this.view$ = combineLatest([this.flows$, this.runs$, this.users$, this.state$, this.search$, this.monitorService.flow$]).pipe(map(([flows, runs, users, state, search, monitorFlows])=>{

            this.flowTags = flows.reduce( (a, b): string[] => [...a, ...b.tags], []).filter(distinct).sort();
            this.flowTriggers = flows.map( flow => flow.trigger ).filter(distinct).sort();
            this.flowTriggerKinds = flows.map( flow => flow.triggerKind ).filter(distinct).sort();
            this.flowStates = flows.map( flow => flow.flowState ).filter(distinct).sort();
            this.flowActions = flows.reduce( (a, b): string[] => [...a, ...b.flowActions], []).map( (a)=> {                
                let m = /(.+?)(?:\s\((\d+)\))?$/gi.exec(a);
                if (m) {
                    return m[1];
                }
                return a;
            }).filter(distinct).sort();

            const allOwners = getOwners(flows.reduce( (a, b): string[] => [...a, ...b.shareOwners], []).filter(distinct).sort(), users);            
            this.allOwners.next(allOwners); 

            const data = flows.filter( (flow)=> {
                return (
                    !search ||
                    includes((flow.displayName), search) ||
                    flow.tags.find( (tag)=> includes((tag), search) ) != null ||
                    includes( flow.trigger, search) ||
                    includes( flow.triggerKind, search ) ||
                    includes( flow.modified?.toISOString(), search) ||
                    includes( flow.lastRun?.toISOString(), search)
                );
            });

            // let data = flows;
            // if (search) {
            //     let filter_d = null;
            //     try {
            //         filter_d = Date.parse(search)
            //     }
            //     catch {
    
            //     }
    
            //     let filter: CompositeFilterDescriptor = {
            //         "logic": "or",
            //         "filters": [
            //         ],
            //     };
            //     if (search) {
            //         filter.filters.push(...[
            //             { "field": "displayName", "operator": "contains", "value": `${search}` },
            //             { "field": "tags", "operator": "contains", "value": `${search}` },
            //             { "field": "trigger", "operator": "contains", "value": `${search}` },
            //             { "field": "triggerKind", "operator": "contains", "value": `${search}` },
            //         ]);
            //     }
            //     if (filter_d) {
            //         filter.filters.push(...[
            //             { "field": "modified", "operator": "gte", "value": `${filter_d}` },
            //             { "field": "lastRun", "operator": "gte", "value": `${filter_d}` },
            //         ]);
            //     }
                
            //     data = filterBy(data, filter);
            // }
            if (data.length < state.skip) {
                // if (this.grid){
                //     this.grid.scrollTo({row:0});
                // }    
                state.skip = 0;
            }

            if (runs != null && runs.length > 0) {
                const groupRuns = groupBy(runs, 'flowName');
                Object.keys(groupRuns).forEach((flowName)=>{

                    const runs = groupRuns[flowName];
                    let flow = flows.find((f)=>f.flowName == flowName);
                    if (flow) {
                        flow.runs = runs;
                    }
                }) 
            }
            if (this.licenseHasTeams && monitorFlows != null && monitorFlows.length > 0) {

                (monitorFlows || []).filter((f)=> f.monitor).map((f)=>f.name)
                .forEach((flowName)=>{
                    let flow = flows.find((f)=>f.flowName === flowName);
                    if (flow) {
                        flow.monitored = true;
                    }
                })
            }

            const d = process(data, state);

            // [admin-trace] Diagnose grid emptiness on /admin: log what view$
            // emits to the grid so we know whether the drop is in the source
            // observable, env filter, search filter, or the Kendo `process`.
            adminTrace(`[admin-trace] view$-emit fieldIsAdmin=${this.fieldIsAdmin} flows.length=${flows.length} dataAfterSearch=${data.length} resultTotal=${d?.total} resultDataLen=${d?.data?.length} state=${JSON.stringify({skip: state?.skip, take: state?.take, filterCount: state?.filter?.filters?.length})} search=${JSON.stringify(search)}`);

            // const scrollable = d.total > 150 ? "virtual" : "scrollable";
            // if (this.scrollable$.value != scrollable) {
            //     this.scrollable$.next(scrollable);
            // }
            // console.log(state);
            return d;
        }));
        this.subscriptions.add(this.view$.subscribe());
        this.allData = this.allData.bind(this);

        // this.popupService.onClose.subscribe((e:PopupCloseEvent)=>{
        //     e.preventDefault();
        // });
    }

    ngOnChanges(changes: SimpleChanges) {

        let change = changes['display'];

        if (change != null) {
            let current  = JSON.stringify(change.currentValue);
            let previous = JSON.stringify(change.previousValue);

        }
    }

    ngOnInit() {
        //this.environment = localStorage.getItem("env");
        //this.refreshEnvironment(this.environment);

        // this.route.params.subscribe(params => {
        //     this.environment = params['environment'];
        //     //this.service.get(term).then(result => { console.log(result); });
        //     this.refreshEnvironment(this.environment, true);
        // });
        switch(this.display) {
            case 'by-actions': {
                this.fieldRuns = false;
                this.fieldSelectable = false;
                break;
            }
        }

        let params = this.params$.value;

        this.storageDexieService.getConfig(Settings.SETTING_GRIDSTATE).then((settings) => {
            if (params?.tags) {
                return;
            }
            if (settings && settings.value) {
                settings.value.take = 100;
                settings.value.skip = 0;
                this.dataStateChange(settings.value);
            }
        });
        // this.storageDexieService.getConfig(Settings.SETTING_GRIDCOLUMNS).then((settings) => {
        //     if (settings && settings.value) {
        //         this.fieldShowActions = (settings.value || []).includes("api");
        //     }
        // });

        this.storageDexieService.getConfig(Settings.SETTING_GRID_COLUMNS_VISIBLE).then(v => {
            if (Array.isArray(v?.value)) { this.visibleColumns = new Set(v.value); }
        }).catch(() => {});
        this.storageDexieService.getConfig(Settings.SETTING_DEPRECATED_TOOLS_VISIBLE).then(v => {
            if (Array.isArray(v?.value)) { this.visibleDeprecatedTools = new Set(v.value); }
        }).catch(() => {});
        this.storageDexieService.getConfig(Settings.SETTING_FLOW_LINKS_VISIBLE).then(v => {
            if (Array.isArray(v?.value)) { this.visibleFlowLinks = new Set(v.value); }
        }).catch(() => {});

        if (params?.tags) {
          this.filterByTag(params.tags);
        }

        // this.storageService.flows.count().then(count => this.cache.flows = count);
        // this.storageDexieService.settingsKeys().then(value=>{
        //     this.cache.settings = value.length
        // });
        // this.storageService.runs.count().then(count => this.cache.runs = count);
        // this.storageService.settings.count().then(count => this.cache.settings = count);
        this.storageDexieService.putConfig(Settings.SETTING_LASTROUTE,{
            'key': Settings.SETTING_LASTROUTE,
            'value': '/flows'
        });

        this.subscriptions.add(this.flowManagementService.currentEnvironment$.subscribe((environment) => {
            this.refreshEnvironment(environment);
        }));
        this.subscriptions.add(this.router.events.subscribe((e: any) => {
            // If it is a NavigationEnd event re-initalise the component
            if (e instanceof NavigationEnd) {
                this.refreshEnvironment(this.environment$.value, true);
            }
        }));

        // this.paymentService.checkSubscription(true).then((status)=>{
        //   this.fieldIncludeSolution$.next(status);
        // });

        this.subscriptions.add(this.state$.subscribe((state)=>{
            this.state = state;
        }));

        this.checkToken();
    }

    checkToken() {
        if (this.flowManagementService && this.flowManagementService.currentEnvironment) {
            this.refreshEnvironment(this.flowManagementService.currentEnvironment);
            return;
        }
        setTimeout(this.checkToken, 500);
    }

    ngOnDestroy() {
        // Treat unmount as a cancel — bumps `_scanGeneration` so any in-flight
        // scan promise chain self-aborts before its `.finally` writes the
        // refresh timestamp, and cancels pending HTTP. Without this, navigating
        // away mid-scan still records a "fresh" timestamp once the dangling
        // chain settles, so the next visit thinks the cache is current and
        // skips the network. Same guard works for /flows and /admin.
        this.cancel();
        this.subscriptions.unsubscribe();
    }

    // ngOnChanges(changes: SimpleChanges) {
    //     const env: SimpleChange = changes.environment;
    //     if (env.currentValue != env.previousValue) {
    //         this.refreshEnvironment(env.currentValue);
    //     }
    // }

    // private async loadFlowsFromStorage(env: string){
    //   const flows = await this.storageService.getFlows(env);
    //   this.flows$.next(flows);
    // }

    private reportRefreshProgress(label: string, status: 'running' | 'done' | 'failed' | 'cancelled', completed?: number, total?: number): void {
        this.flowEventService.reportProgress({
            id: 'refresh-pipeline',
            group: this.fieldIsAdmin ? 'admin' : 'flows',
            label,
            status,
            completed,
            total
        });
    }

    private async refreshEnvironment(env: string, force: boolean = false, refreshRuns: boolean = true) {
        if (!env) {
            return;
        }
        if (env == this.environment$.value && !force) {
            return;
        }

        // Increment generation so any in-flight promise chain from a previous env switch
        // will see a stale generation and abort early.
        const gen = ++this._scanGeneration;
        console.log(`[flows] refreshEnvironment gen=${gen} env=${env} force=${force}`);
        this.environment$.next(env);

        // Staleness check: if we scanned this env recently, skip the network and
        // let the existing OPFS subscriptions hydrate flows$ from cache. Use
        // the admin-scope timestamp when this is the /admin grid; the user-scope
        // and admin-scope scans hit different upstream endpoints and have their
        // own freshness clocks.
        let scanCompletedAt: number | null = null;
        if (!force) {
            const stored = await this.storageDexieService.getEnvironment(env).catch(() => null);
            scanCompletedAt = this.fieldIsAdmin
                ? (stored?.flowsAdminScannedAt ?? null)
                : (stored?.scanCompletedAt ?? null);
            const scanStaleMs = await this.getEnvironmentScanStaleMs();
            const isFresh = scanCompletedAt != null
                && (Date.now() - scanCompletedAt) < scanStaleMs;
            if (isFresh) {
                if (gen !== this._scanGeneration) return;
                console.log(`[flows] env=${env} is fresh (scanCompletedAt=${new Date(scanCompletedAt).toISOString()}) — hydrating from OPFS only`);
                this.loading$.next(false);
                this.flowEventService.scanLoading$.next(false);
                this.loaded = true;
                this.ready = true;
                return;
            }
        }

        var weeks = addDays(getDate(new Date()), -14);
        if (this.debug) {
            refreshRuns = false;
        }

        this.loading$.next(true);
        this.flowEventService.scanLoading$.next(true);
        this.reportRefreshProgress('Starting refresh', 'running');

        // Phase-aware status: distinguish first cache build (slow, ~30s) from refresh.
        const isFirstLoad = scanCompletedAt == null && !force;
        this.flowManagementService.serviceStatus$.next(
            isFirstLoad
                ? `First load for ${env} — building cache, this may take ~30s`
                : `Refreshing flows for ${env}…`
        );

        let getRuns = false;
        let getTrigger = false;
        if (this.debug) {
            getRuns = false;
            getTrigger = false;
        }

        const flows$ = new BehaviorSubject([]);

        const t0 = Date.now();
        let listScanSucceeded = false;
        const lease = await this.browserCacheCoordination.claimWriteLease();
        if (!lease.ok) {
            if (gen !== this._scanGeneration) return;
            const owner = lease.blockedBy?.ownerId ? lease.blockedBy.ownerId.slice(0, 8) : 'another tab';
            this.flowManagementService.serviceStatus$.next(`Refresh already running in another tab (${owner})`);
            this.reportRefreshProgress(`Refresh already running in another tab (${owner})`, 'done');
            this.loading$.next(false);
            this.flowEventService.scanLoading$.next(false);
            this.loaded = true;
            this.ready = true;
            return;
        }
        this.scanLeaseGeneration = gen;

        this.flowManagementService.scan(this.environment$.value, this.fieldIsAdmin, this.fieldIncludeSolution).then(async (x)=>{

            if (gen !== this._scanGeneration) {
                console.log(`[flows] scan gen=${gen} superseded by gen=${this._scanGeneration}, aborting`);
                this.reportRefreshProgress('Refresh cancelled', 'cancelled');
                return Promise.resolve();
            }

            listScanSucceeded = true;

            // Checkpoint 1: flow list durable. If the tab closes now, baseline survives.
            this.reportRefreshProgress('Saving flow list to cache', 'running');
            await this.storageDexieService.flush()
                .catch((err) => console.warn('[flows] flush after scan() failed', err));

            this.flowManagementService.serviceStatus$.next("Rendering");
            this.reportRefreshProgress('Rendering grid', 'running');
            this.loading$.next(false);

            // Yield to the browser so the grid paints flow rows before the
            // runs fetch grabs network/CPU. setTimeout(0) over rAF so it still
            // fires when the tab is backgrounded.
            await new Promise<void>((r) => setTimeout(() => r(), 0));

            this.reportRefreshProgress('Fetching runs', 'running');
            return this.doRefreshRuns();
        }).then(()=>{
            if (gen !== this._scanGeneration) return;
            this.reportRefreshProgress('Checking flow details', 'running');
            return this.flowManagementService.scan2(this.environment$.value, this.fieldIsAdmin, this.fieldIncludeSolution);
        }).catch((err) => {
            console.error(`[flows] refreshEnvironment chain error. message=${err?.message} name=${err?.name} code=${err?.code} listScanSucceeded=${listScanSucceeded} fieldIsAdmin=${this.fieldIsAdmin} stack=`, err?.stack, ' full:', err);
            this.reportRefreshProgress('Refresh failed', 'failed');
        }).finally(async ()=>{
            if (gen !== this._scanGeneration) return;
            this.reportRefreshProgress('Finalizing refresh', 'running');
            this.flowManagementService.serviceStatus$.next("");
            this.loading$.next(false);
            this.flowEventService.scanLoading$.next(false);
            this.loaded = true;
            this.ready = true;

            // Completion gate: list fetch must have succeeded; scan2 may have succeeded
            // or thrown (caught by finally). Write only once per scan, scoped to this env.
            if (listScanSucceeded) {
                // Checkpoint 2: final flush — scan state and data land together.
                await this.storageDexieService.flush()
                    .catch((err) => console.warn('[flows] flush before markEnvScanCompleted failed', err));
                // Re-check generation AFTER the flush await — navigation could
                // have bumped it during that yield. Skipping the timestamp here
                // means the next visit will see "stale" and refresh again.
                if (gen !== this._scanGeneration) return;
                const flowCount = (this.flows$.value || []).length;
                // Record the timestamp under the column that matches this grid's
                // scope. /admin and /flows have separate freshness clocks so the
                // header reload-button shows the right "Refreshed Xm ago" per page.
                await this.storageDexieService
                    .markEnvSourceScanned(env, this.fieldIsAdmin ? 'flowsAdmin' : 'flows', flowCount, Date.now() - t0)
                    .catch((err) => console.warn('[flows] markEnvSourceScanned failed', err));
                this.browserCacheCoordination.broadcastCacheInvalidated(
                    ['flows', 'runs', 'environments'],
                    this.fieldIsAdmin ? 'admin-flow-scan-complete' : 'flow-scan-complete'
                );
                this.reportRefreshProgress(`Refresh complete (${flowCount} flows)`, 'done', flowCount, flowCount);
            }
            if (this.scanLeaseGeneration === gen) {
                this.scanLeaseGeneration = null;
                this.browserCacheCoordination.releaseWriteLease();
            }
        });
        
        // var pFlows = this.flowManagementService.getFlows(this.environment, false, false);
        // var pLastLoadTime = this.storageDexieService.getConfig(Settings.SETTING_LASTLOAD);
        // Promise.all([pFlows, pLastLoadTime]).then(([flows, lastLoadTime]) => {

        //     this.cdr.detach();
        //     //var cachedRuns: FlowRun[] = values[1];
        //     let runPromises = [];
        //     //var lastLoadTime = values[2];
        //     //     this.events = events;
        //     if (refreshRuns && !force && ((lastLoadTime?.value - (new Date()).getTime()) < (15 * 60 * 1000))) {
        //         refreshRuns = false;
        //     }

        //     this.flowManagementService.serviceStatus$.next(`Fetching Flow Runs`);


        //     flows.forEach(flow => {

        //         if (refreshRuns || flow.runs.length == 0) {
        //             if (flows.length <= 50 || flow.flowState != "Stopped") {

        //                 const runs$ = this.flowManagementService.getFlowRuns$(flow.environment, flow.flowName, false);

        //                 const pRuns = runs$.toPromise();
        //                 pRuns.then((runs)=>{
        //                     flow.runs = runs;
        //                 });
        //                 runPromises.push(pRuns);
        //             }
        //         }
        //     });

        //     var lastTick = Date.now() - (1000 * 60 * 60 * 24 * 30 /* one day short of 31 */);
        //     if (lastLoadTime.value > lastTick) {
        //         lastTick = lastLoadTime.value;
        //     }
        //     var lastCheckDate = new Date(lastTick);

        //     if (this.display) {

        //         let pConnections = this.flowManagementService.getConnections(env).then((connections)=>{
        //             this.connections = connections;
        //         });

        //         runPromises.push(pConnections);
        //     }

        //     return Promise.all(runPromises).then((): any => {
        //         this.flowManagementService.serviceStatus$.next("Saving Updated Flows");
        //         if (refreshRuns) {
        //             return this.storageDexieService.putConfig(
        //                 Settings.SETTING_LASTLOAD,
        //                 { 
        //                     key: Settings.SETTING_LASTLOAD, 
        //                     value: (new Date()).getTime() 
        //                 });
        //         }
        //         else {
        //             return true;
        //         }
        //     }).then(() => {
        //         this.flowManagementService.serviceStatus$.next("Rendering");
        //         this.loading$.next(false);
        //         this.flowTags = flows.reduce( (a, b): string[] => [...a, ...b.tags], []).filter(distinct).sort();
        //         this.flowTriggers = flows.map( flow => flow.trigger ).filter(distinct).sort();
        //         this.flowTriggerKinds = flows.map( flow => flow.triggerKind ).filter(distinct).sort();
        //         this.flowStates = flows.map( flow => flow.flowState ).filter(distinct).sort();
        //         this.flowActions = flows.reduce( (a, b): string[] => [...a, ...b.flowActions], []).filter(distinct).sort();

        //         //this.view = process(this.flows, this.state);
        //         this.flows$.next(flows);
        //         this.flowEventService.flowsUpdated$.next(true);

        //         //this.analytics.send("flows", "flows", "count", );
        //         this.appInsights.trackEvent(`flows`, { "flows": flows.length });

        //     }).finally(()=>{
        //         this.flowManagementService.serviceStatus$.next("");
        //     });

        // }).finally(()=>{
        //     this.cdr.reattach();
        //     this.loading$.next(false);
        //     this.loaded = true;
        //     this.ready = true;
        // });

    }

    private async getEnvironmentScanStaleMs(): Promise<number> {
        const setting = await this.storageDexieService.getConfig(Settings.SETTING_AUTO_REFRESH_HOURS).catch(() => null);
        const hours = Number(setting?.value);
        if (!Number.isFinite(hours)) {
            return ENV_SCAN_STALE_MS;
        }
        return Math.max(ENV_SCAN_STALE_MS, hours * 60 * 60 * 1000);
    }

    reload() {
        // this.flows = [];
        // this.view = process(this.flows, this.state);
        this.refreshEnvironment(this.environment$.value, true);
    }

    cancel(){
        // Bump generation so any in-flight scan promise chain self-aborts
        // before its completion-hook fires (preventing a stray markEnvScanCompleted).
        this._scanGeneration++;
        this.httpCancelService.cancelPendingRequests();
        this.flowManagementService.serviceStatus$.next("");
        this.loading$.next(false);
        this.flowEventService.scanLoading$.next(false);
        if (this.scanLeaseGeneration != null) {
            this.scanLeaseGeneration = null;
            this.browserCacheCoordination.releaseWriteLease();
        }
    }

    // public pageChange(state: DataStateChangeEvent) {
    //     this.state$.next(state);
    // }

    public dataStateChange(state: DataStateChangeEvent): void {

        const oldState = this.state$.value;

        if (state.sort && state.sort.length == 1) {
            // only on 1

            var field = state.sort[0].field;

            if (!oldState.sort || field !=  oldState.sort[0].field) {

                var desc = this.grid.columns.filter((c:any)=>{return c.field == field && (c.filter == "date" || c.filter == "number"); }).length > 0;

                if (desc) {
                    state.sort[0].dir = "desc";
                }
            }
        }

        const newState = {
            filter: (typeof(state.filter)=="function" ? oldState.filter : state.filter),
            group: state.group,
            sort: state.sort,
            skip: state.skip,
            take: state.take
        }

        this.state$.next(newState);

        setTimeout(()=>{
            this.storageDexieService.putConfig(
                Settings.SETTING_GRIDSTATE,
                {
                    'key': Settings.SETTING_GRIDSTATE,
                    value: newState
                });        
        },1);
        //this.view = process(this.flows, this.state);
    }

    filterByTag(tag: string) {
        var state: any = this.state$.value;
        if (tag) {
            tag = (tag.startsWith('#') ? tag : `#${tag}`);
            if (state.filter.filters && state.filter.filters.length && state.filter.filters[0].value == tag) {
                state.filter.filters = [];
            }
            else {
                state.filter.filters = [{
                    "field": "tags",
                    "operator": "contains",
                    "value": tag
                }];
                state.skip = 0;
            }
        }
        else {
            state.filter.filters = [];
        }
        this.dataStateChange(state);
    }

    filterByTrigger(trigger: string) {
        var state: any = this.state$.value;
        if (trigger) {
            if (state.filter.filters && state.filter.filters.length && state.filter.filters[0].value == trigger) {
                state.filter.filters = [];
            }
            else {
                state.filter.filters = [{
                    "field": "trigger",
                    "operator": "contains",
                    "value": trigger
                }];
                state.skip = 0;
            }
        }
        else {
            state.filter.filters = [];
        }
        this.dataStateChange(state);
    }

    filterBy(field: string, value: string, toggle: boolean = true) {
        var state: any = this.state$.value;
        if (value) {
            if (state.filter.filters && state.filter.filters.length && state.filter.filters[0].value == value && toggle) {
                state.filter.filters = [];
            }
            else {
                state.filter.filters = [{
                    "field": field,
                    "operator": "contains",
                    "value": value
                }];
                state.skip = 0;
            }
        }
        else {
            state.filter.filters = [];
        }
        this.dataStateChange(state);
    }

    filterByTriggerKind(triggerKind: string) {
        this.filterBy("triggerKind", triggerKind);
    }

    filterByFlowState(flowState: string) {
        this.filterBy("flowState", flowState);
    }

    filterByFlowAction(flowAction: string) {
        this.filterBy("actionsTooltip", flowAction, true);
    }

    clearFilter() {
        this.search$.next('');
        let state : State = this.state$.value;
        state.filter = {
            filters: [],
            logic: "or"
        };

        const stateChange:DataStateChangeEvent = {
            ...state,
            skip:0,
            take:100
        }
        this.dataStateChange(stateChange);
    }

    hasFilter$ = combineLatest([this.state$, this.search$]).pipe(map((value)=>{
        const [state,search] = value;
        let hasFilter = false;
        try {
            hasFilter = !!search || state.filter.filters.length > 0;
        }
        catch(e){
            // nothing.
        }
        return hasFilter;
    }));

    hasRuns(dataItem: any, index: number) {
        return dataItem.runsCount > 0;
    }

    runsCountTotal$ = this.flows$.pipe(map((flows)=>{
        if (!flows || !flows.length) {
            return 0;
        }
        return flows.map(flow => flow.runsCount).reduce((total, count) => {
            return total + count;
        });
    }))

    // get runsCountTotal() {
    //     if (!this.flows || !this.flows.length) {
    //         return 0;
    //     }
    //     return this.flows.map(flow => flow.runsCount).reduce((total, count) => {
    //         return total + count;
    //     });
    // }

    runsFailCountTotal$ = this.flows$.pipe(map((flows)=>{
        if (!flows || !flows.length) {
            return 0;
        }
        return flows.map(flow => flow.runsFailCount).reduce((total, count) => {
            return total + count;
        });
    }))

    // get runsFailCountTotal() {
    // }

    // get flowTags() : Observable<string[]> {
    //     return of(this.flows).pipe(debounceTime(400), map( (flows:Flow[]) => flows.reduce( (a, b): string[] => [...a, ...b.tags], []).filter((value, index, self) => self.indexOf(value) === index)));
    // }


    async clearRuns() {
        // await this.storageService.runs.clear();
        // await this.storageService.runs.count().then(count => this.cache.runs = count);
    }

    parseAction(actions: string): any {

        let name = actions;
        let background = 'slateblue';
        let image = '';

        let m1 = /(.+?)\.(.+?)(?:\s\((\d+)\))?$/gi.exec(actions);
        if (m1) {
            name = `${m1[1]}.${m1[2]}`;

            let connection = this.connections.find(c=>c.apiId == `/providers/Microsoft.PowerApps/apis/${m1[1]}`);
            if (connection) {
                image = connection.iconUri;
            }
        }
        else {
            let m2 = /(.+?)(?:\s\((\d+)\))?$/gi.exec(actions);
            if (m2) {
                name = `${m2[1]}`;
            }
        }

        switch(name) {
            case 'Request':
            case 'Response':
            case 'Http':
                background = 'rgb(0, 157, 165)';
                break;
            case 'InitializeVariable':
            case 'IncrementVariable':
                background = 'rgb(119, 11, 214)';
                break;
            case 'Scope':
                background = 'rgb(140, 57, 0)';
                break;
            case 'Foreach':
            case 'Compose':
            case 'ParseJson':
            case 'Select':
            case 'Query':
            case 'Expression':
            case 'Table':
                background = 'rgb(140, 108, 255)';
                break;
            case 'If':
                background = 'rgb(70, 79, 89)';
                break;
            case 'Terminate':
                background = 'rgb(244, 23, 0)';
                break;
        }

        return {
            'short': actions.substring(0,1).toUpperCase(),
            'name': name,
            'background': background,
            'image': image
        }
    }

    get flowsLoaded$(): Observable<boolean> {
        return this.flowsLoading$.pipe(map(c=>c==0));
        //return this.flows.filter(flow => flow.loading).length > 0;
    }

    // get flowsLoading$(): Observable<number> {
    //     return from(this.flows).pipe(count(f=>f.loading));
    //     //return this.flows.filter(flow => flow.loading).length;
    // }

    resolveOwners$(flow: Flow) {
        const ids = flow.ownerIds;
        if (ids.length === 0) {
            // No co-owners list — fall back to creator OID (admin LIST always returns it),
            // then to the current MSAL user. Resolve through the sqlite users table.
            const oid = flow.creatorOid || null;
            if (oid) {
                return this.resolveUser$(oid).pipe(
                    map(user => this.formatUser(user, null, oid))
                );
            }
            return this.msalHelperService.user$.pipe(
                switchMap(account => {
                    const accountOid = account?.localAccountId;
                    if (!accountOid) return of('');
                    return this.resolveUser$(accountOid).pipe(
                        map(user => this.formatUser(user, account))
                    );
                })
            );
        }
        return combineLatest(
            ids.map((ownerId)=>{
                return this.resolveUser$(ownerId)
            })).pipe(map((users)=>{
                return users.map((user, i)=>this.formatUser(user, null, ids[i])).join(', ');
            }))
    }

    private formatUser(user: any, account?: any, fallbackId?: string): string {
        const name = user?.displayName || account?.name || '';
        const email = user?.email || account?.username || '';
        if (name && email) return `${name} <${email}>`;
        return name || email || fallbackId || '';
    }

    public hasSingleOwner(flow: Flow): boolean {
        if (flow.owners?.length === 1) return true;
        const st = flow.sharingType || '';
        if (st.includes('Coauthor') || st.includes('DelegatedAuth')) return false;
        // Show the contact icon when we know who the creator is (admin LIST gives us
        // creator.objectId) or when this is a personal flow (userType === 'Owner').
        if (!flow.owners || flow.owners.length === 0) {
            if (flow.creatorOid) return true;
            if (flow.userType === 'Owner' && !st.includes('CommonDataService')) return true;
        }
        return false;
    }

    resolveUser$(userid: string) {
        return this.users$.pipe(map(users=>users.find(u=>u.key.endsWith(userid))));
    }

    public bgColor(flow: Flow) {
        var tags = flow.tags || [];

        for (var i = 0; i < tags.length; i++) {
            var tag = tags[i].replace('#', '').toLowerCase();

            if (typeof colours[tag] != 'undefined') {
                //return tag;
                return this.sanitizer.bypassSecurityTrustStyle(tag);
            }
        }
        return null;
    }

    // get ready(): boolean {
    //     var env = this.flowManagementService.currentEnvironment;
    //     return this.loaded && !!env;
    // }

    getSafeUrl(url): SafeUrl {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    reContextMenu(e:MouseEvent):void{
        let evt = new MouseEvent('contextmenu',{
            bubbles:true,
            clientX: e.clientX,
            clientY: e.clientY
        });
        e.target.dispatchEvent(evt);
        e.stopPropagation();
    }

    public runAction(item: string): void {
        const [first] = this.getSelectedFlows();
        this.onSelect({ dataItem: first ?? null, item });
    }

    public onSelect({ dataItem, item }): void {

        //this.analytics.send("flows", item);
        //this.appInsights.logPageView(`flows: ${item}`);
        this.appInsights.trackEvent(`flows`, { "select": item });

        switch (item) {
            case "Disable": {

                this.doConfirmDisable(dataItem);
                break;
            }
            case "Enable": {

                this.doConfirmEnable(dataItem);
                break;
            }
            case "Edit JSON": {
                this.navigateToFlowTab(dataItem, 'json');
                break;
            }
            case "Edit in Designer": {
                this.doEdit(dataItem);
                break;
            }
            case "Run Now": {

                this.doRunNow(dataItem);
                break;
            }
            case "Duplicate": {
                this.confirmDuplicate(dataItem);
                break;
            }
            case "Cancel All Runs": {
                this.confirmCancelRuns(dataItem);
                break;
            }
            case "Delete":
            case "Delete Flow": 
                this.confirmDeleteFlows(dataItem);
                break;
            case "Tag":
            case "Tags": 
                this.doTags(dataItem);
                break;            
            case "Get More Runs (slow)": {
                this.doGetRuns(dataItem, true);
                //this.flowManagementService.getFlowRuns(dataItem, true, true);
                break;
            }
            case "Get Latest Runs": {
                this.navigateToFlowTab(dataItem, 'runs');
                break;
            }
            case "Reset Trigger": {
                this.flowManagementService.resetTrigger(dataItem).then(() => {
                    console.log('Trigger Reset');
                });
                break;
            }
            case "Export Excel": {
                this.doExcel();
                break;
            }
            case "Flow Diagram": {
                this.navigateToFlowTab(dataItem, 'diagram');
                break;
            }
            case "Rename Actions": {
                this.doRenameActions(dataItem);
                break;
            }
            case "Team Details": {
                this.doTeamDetails(dataItem);
                break;
            }
            case "Owners": {
                this.doEditOwners(dataItem);
                break;
            }
            case "Versioning":
            case "Snapshots": {
                this.navigateToFlowTab(dataItem, 'snapshots');
                break;
            }
            case "Solution Aware": {
                this.doSolutionAware(dataItem);
                break;
            }
            case "Grant Admin as Flow Owner": {
                this.doAddOwner(dataItem);
                break;
            }
            case "Restore Soft Deleted Flow as Admin": {
                this.restoreFlowAsAdmin(dataItem);
                break;
            }
            default:
                break;
        }

    }

    public onFilter(menuItems: any[]) {
        return menuItems.filter(item => {
            const text = typeof item === 'string' ? item : item?.text;
            if (text === 'New' && !this.isToolVisible('newSubmenu')) return false;
            if (text === 'Edit in Designer' && !this.isToolVisible('editInDesigner')) return false;
            return true;
        });
    }

    // get gridFilters(): (CompositeFilterDescriptor|FilterDescriptor)[] {
    //     return this.state.filter ? this.state.filter.filters : [];
    // }

    public async doRefreshRuns() {
        try {
            this.loading$.next(true);
            console.log(`[doRefreshRuns] start admin=${this.fieldIsAdmin} env=${this.environment$.value}`);
            await this.flowManagementService.scanRuns(this.fieldIsAdmin, this.environment$.value);
            console.log(`[doRefreshRuns] scanRuns completed`);
        }
        finally {
            this.loading$.next(false);
        }
    }

    public async doGetRuns(flow: Flow, deep: boolean = false, state = null) {

        if (deep) {
            var status = await this.paymentService.checkSubscription();
            if (!status) return;
        }

        this.router.navigate(['/flows', flow.environment, flow.flowName, 'view'], {
            queryParams: {
                tab: 'runs',
                ...(this.fieldIsAdmin ? { admin: true } : {}),
                ...(deep ? { deep: true } : {}),
                ...(state ? { status: state } : {})
            }
        });

    }

    /**
     * Whitelist of grid columns whose cells navigate to the flow's runs page
     * when clicked. Anything outside this list lets the default cell-click
     * (row selection) behaviour through.
     *
     * Notable exclusion: `displayName` — the cell already has an inline
     * `<a routerLink="…/view">` for the flow name, so clicking the link goes
     * to /view. Empty space in the same cell shouldn't surprise the user by
     * navigating to /runs.
     *
     * The remaining entries are run-stat columns where the entire cell area
     * is meaningfully tied to "show me the runs".
     */
    private readonly NAVIGATE_ON_CLICK_FIELDS = new Set<string>([
        'runscolorbar', 'runssort', 'runsfailcount', 'lastrun',
    ]);

    public openRunsFromGridCell(event: any) {
        const target = event?.originalEvent?.target as HTMLElement;
        const closestSelector = 'a,button,input,kendo-checkbox,input[type="checkbox"],.ms-Icon--More,.hover-only';
        const closestMatch = target?.closest(closestSelector) as HTMLElement | null;
        const rawField = event?.column?.field;
        const columnField = `${rawField || ''}`.toLowerCase();
        const inWhitelist = this.NAVIGATE_ON_CLICK_FIELDS.has(columnField);

        // ---- DIAGNOSTIC LOGGING (commented out) --------------------------------
        // Re-enable when the row-click navigation rules need debugging again.
        // Search "[grid-click]" in the console after un-commenting.
        // console.log('[grid-click]', {
        //     targetTag: target?.tagName,
        //     targetClass: target?.className,
        //     closestMatchTag: closestMatch?.tagName,
        //     closestMatchClass: closestMatch?.className,
        //     rawColumnField: rawField,
        //     columnFieldLower: columnField,
        //     columnTitle: event?.column?.title,
        //     inWhitelist,
        //     fieldSelectableMulti: this.fieldSelectableMulti,
        //     hasEnv: !!event?.dataItem?.environment,
        //     hasFlowName: !!event?.dataItem?.flowName,
        // });
        // ------------------------------------------------------------------------

        const flow = event?.dataItem as Flow;
        if (!flow?.environment || !flow?.flowName || this.fieldSelectableMulti) {
            // console.log('[grid-click] skip: missing flow / multi-select active');
            return;
        }

        if (closestMatch) {
            // console.log('[grid-click] skip: closest() matched', closestMatch.className);
            return;
        }

        if (!inWhitelist) {
            // console.log('[grid-click] skip: column not in whitelist');
            return;
        }

        // console.log('[grid-click] NAVIGATE → /flows/' + flow.environment + '/' + flow.flowName + '/runs');
        // Navigate to the runs route instead of opening the legacy dialog.
        this.navigateToFlowTab(flow, 'runs');
    }

    public doEditOwners(flow: Flow){

        // this.filterBy("displayName", flow.displayName, false);

        const dialogRef = this.windowService.open({
            title: `Owners: ${flow.displayName}`,
            content: FlowDetailComponent,
            keepContent: false,
            //minHeight: 800,
            minWidth: 1000,

            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });
        const flowComponent: FlowDetailComponent = dialogRef.content.instance;
        flowComponent.editorType = 'FlowOwners';
        flowComponent.flow = flow;
    }

    public async doTeamDetails(flow: Flow) {
        // var status = await this.paymentService.checkSubscription();
        // if (!status) return;

        const dialogRef = this.windowService.open({
            title: 'Monitor: ' + flow.displayName,
            content: DetailsComponent,
            keepContent: false,
            minHeight: 600,
            minWidth: 800,

            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });
        const flowComponent: DetailsComponent = dialogRef.content.instance;
        flowComponent.flow = flow;

    }

    public async doMonitor(dataItem: Flow = null) {

        const flows = this.getSelectedFlows(dataItem);

        let title = `Monitor Flow`;

        const monitored = (flows || []).filter((f)=>f.monitored).length;
        const monitor = monitored < flows.length;
        if (monitor) {
            title = `Start Monitoring Flow` + ((flows.length > 1) ? `s (${flows.length})` : '');
            // on
        }
        else {
            title = `Stop Monitoring Flow` + ((flows.length > 1) ? `s (${flows.length})` : '');
            // off
        }

        if (flows.length > 1) {
            const names = flows.map(f => {
                return f.displayName;
            });

            this.items = names;
        }
        else if (flows.length == 1) {
            const [flow ] = flows;
            this.items = [flow.displayName];
        }
        else {
            return;
        }

        const dialog: DialogRef = this.dialogService.open({
            title: title,
            content: this.multiConfirmTemplate,
            // content: `Are you sure - we will turn ON the selected ${content}`,
            actions: [
                { text: 'Yes', primary: true },
                { text: 'No' }
            ],
            width: 450,
            // height: 200,
            minWidth: 250
        });
        var result: any = await dialog.result.toPromise();

        if (result.text != 'Yes') {
            return;
        }

        flows.forEach(f=>{
            this.monitorService.mutateFlow(`${this.environment$.value}.${f.flowName}`, {
                displayName: f.displayName,
                monitor: monitor
            }, (update)=>{
                f.monitored = monitor;
            });
        });

    }

    public async doRenameActions(flow: Flow) {

        var status = await this.paymentService.checkSubscription();
        if (!status) return;

        const dialogRef = this.windowService.open({
            title: 'Rename Action: ' + flow.displayName,
            content: FlowRenameComponent,
            keepContent: false,
            minHeight: 600,
            minWidth: 800,

            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });
        const flowComponent: FlowRenameComponent = dialogRef.content.instance;
        flowComponent.flow = flow;
    }

    public async doSolutionAware(flow: Flow) {

        var status = await this.paymentService.checkSubscription();
        if (!status) return;

        const dialogRef = this.windowService.open({
            title: 'Make Solution Aware...',
            content: FlowSolutionComponent,
            keepContent: false,
            minHeight: 300,
            minWidth: 400,

            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });
        const flowComponent: FlowSolutionComponent = dialogRef.content.instance;

        let flows = this.getSelectedFlows(flow);

        flowComponent.flows = flows;
    }

    public doRunNow(flow:Flow) {
        //
        const run = `https://flow.microsoft.com/manage/environments/${flow.environment}/flows/${flow.flowName}/run`;

        window.open(run, '_blank');

        //await this.flowManagementService.runFlow(flow.environment, flow.flowName, flow.triggers).toPromise();
    }

    public async confirmDuplicate(flow: Flow) {

        try {
            this.loaded = false;
            var flowSource = await this.flowManagementService.getFlow(flow.environment, flow.flowName).toPromise();
            var flowData = {
                "properties": {
                    "definition": flowSource.properties.definition,
                    "connectionReferences": flowSource.properties.connectionReferences,
                    "displayName": flowSource.properties.displayName + " Copy",
                    "templateName": flowSource.properties.templateName,
                    "environment": {
                        "name": flow.environment
                    },
                    "state": "Stopped",
                }
            };

            await this.flowManagementService.createFlow(flow.environment, flowData).toPromise();

            this.refreshEnvironment(this.environment$.value, true, false);

        }
        finally {
            this.loaded = true;
        }
    }

    public async confirmCancelRuns(flow: Flow) {
        const flows = this.getSelectedFlows(flow);
        if (!flows.length) return;

        this.items = flows.map(f => f.displayName);
        const title = flows.length > 1
            ? `Cancel All Runs (${flows.length} flows)`
            : `Cancel All Runs`;

        const dialog: DialogRef = this.dialogService.open({
            title,
            content: this.multiConfirmTemplate,
            actions: [
                { text: 'Yes', primary: true },
                { text: 'No' },
            ],
            width: 450,
            minWidth: 250,
        });
        const result: any = await dialog.result.toPromise();
        if (result?.text !== 'Yes') return;

        try {
            this.loaded = false;
            const cancels: Promise<any>[] = [];
            for (const f of flows) {
                (f.runs || []).filter(run => run.status == "Running").forEach(run => {
                    cancels.push(this.flowManagementService.cancelFlowRun(run).toPromise());
                });
            }
            await Promise.all(cancels);
            for (const f of flows) {
                this.flowManagementService.getFlowRuns(f);
            }
        }
        finally {
            this.loaded = true;
        }
    }

    // public getCurrentFlow(flow:Flow): Flow[] {
    //     if (flow) {
    //         return [flow];
    //     }
    //     if (this.selection && this.selection.length) {
    //         return this.flows$.value.filter( f=> this.selection.indexOf(f.flowName) != -1);
    //     }
    //     return [];
    // }

    public async confirmDeleteFlows(dataItem: Flow) {

        // let content = '';
        const asAdmin = this.fieldIsAdmin ? ' As Admin' : '';
        let title = `Delete Flow${asAdmin}`;

        const flows = this.getSelectedFlows(dataItem);
        const [flow ] = flows;

        if (flows.length > 1) {
            //content = `Flows: ${names.join(', ')}`;
            title = `Delete Flows (${flows.length})${asAdmin}`;

            const names = flows.map(f => {
                return f.displayName;
            });

            this.items = names;

        }
        else if (flows.length == 1) {

            this.items = [flow.displayName];
            // content = `Flow: ${flow.displayName}`;
        }
        else {
            return;
        }

        this.deleteConfirmInput = '';
        this.deleteConfirmExpected = flows.length > 1 ? 'DELETE' : flow.displayName;

        const dialog: DialogRef = this.dialogService.open({
            title: title,
            content: this.deleteConfirmTemplate,
            actions: [
                { text: 'Delete', primary: true, themeColor: 'error' },
                { text: 'Cancel' }
            ],
            width: 500,
            minWidth: 300
        });
        var result: any = await dialog.result.toPromise();

        if (result?.text !== 'Delete') return;
        if (this.deleteConfirmInput !== this.deleteConfirmExpected) {
            alert(`Confirmation text did not match "${this.deleteConfirmExpected}". No flows deleted.`);
            return;
        }

        var promises = [];
        if (flows.length > 1) {

            for (var i = 0; i < flows.length; i++) {
                let f = flows[i];

                //console.log(run.name);
                var p = this.flowManagementService.deleteFlow(f, this.fieldIsAdmin).toPromise();
                promises.push(p);
            }
        }
        else {
            var p = this.flowManagementService.deleteFlow(flow, this.fieldIsAdmin).toPromise();
            promises.push(p);
        }

        return Promise.all(promises);
    }

    public doEdit(flow: Flow) {
        const dialogRef = this.windowService.open({
            title: `Designer: ${flow.displayName}`,
            content: FlowEditorComponent,
            keepContent: false,
            minHeight: 600,
            minWidth: 800,
            width: 800,
            top: 10

            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });
        const flowEditorComponent: FlowEditorComponent = dialogRef.content.instance;
        flowEditorComponent.flow = flow;

        dialogRef.result.toPromise().then(()=>{
            //this.flowTags = this.flows$.value.reduce( (a, b): string[] => [...a, ...b.tags], []).filter(distinct).sort();
        });
    }

    public doTags(flow: Flow) {
        const dialogRef = this.dialogService.open({
            title: `Tags: ${flow.displayName}`,
            content: FlowTagsComponent,
            height: 200,
            minWidth: 600,

            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });
        const flowComponent: FlowTagsComponent = dialogRef.content.instance;
        flowComponent.flow = flow;
        flowComponent.flowTags = [].concat(...this.flowTags);

        dialogRef.result.toPromise().then(()=>{
            this.flowTags = this.flows$.value.reduce( (a, b): string[] => [...a, ...b.tags], []).filter(distinct).sort();
        });
    }

    // public async doIncludeSolution() {
    //   var status = await this.paymentService.checkSubscription();
    //   if (!status) return;

    //   this.fieldIncludeSolution$.next(!this.fieldIncludeSolution$.value);
    //   this.reload();
    // }

    public async doConfirmEnable(dataItem: Flow = null) {

        const flows = this.getSelectedFlows(dataItem);

        const asAdmin = this.fieldIsAdmin ? ' As Admin' : '';
        let title = `Turn On Flow${asAdmin}`;
        if (flows.length > 1) {
            title = `Turn On Flows (${flows.length})${asAdmin}`;
            const names = flows.map(f => {
                return f.displayName;
            });

            this.items = names;
        }
        else if (flows.length == 1) {
            const [flow ] = flows;
            this.items = [flow.displayName];
        }
        else {
            return;
        }

        const dialog: DialogRef = this.dialogService.open({
            title: title,
            content: this.multiConfirmTemplate,
            // content: `Are you sure - we will turn ON the selected ${content}`,
            actions: [
                { text: 'Yes', primary: true },
                { text: 'No' }
            ],
            width: 450,
            // height: 200,
            minWidth: 250
        });
        var result: any = await dialog.result.toPromise();

        if (result.text != 'Yes') {
            return;
        }

        flows.forEach(f=>{
            this.flowManagementService.startFlow(this.environment$.value, f.flowName, this.fieldIsAdmin).toPromise().then((response) => {
                f.flowState = "Started";
            });
        });
    }

    public async doConfirmDisable(dataItem: Flow = null) {

        const flows = this.getSelectedFlows(dataItem);

        const asAdmin = this.fieldIsAdmin ? ' As Admin' : '';
        let title = `Turn Off Flow${asAdmin}`;
        if (flows.length > 1) {

            const names = flows.map(f => {
                return f.displayName;
            });

            this.items = names;
            title = `Turn Off Flows (${flows.length})${asAdmin}`;
        }
        else if (flows.length == 1) {
            const [flow ] = flows;
            this.items = [flow.displayName];
        }
        else {
            return;
        }

        const dialog: DialogRef = this.dialogService.open({
            title: title,
            // content: `Are you sure - we will turn OFF the selected ${content}`,
            content: this.multiConfirmTemplate,
            actions: [
                { text: 'Yes', primary: true },
                { text: 'No' }
            ],
            width: 450,
            // height: 200,
            minWidth: 250
        });
        var result: any = await dialog.result.toPromise();

        if (result.text != 'Yes') {
            return;
        }

        flows.forEach(f=>{
            this.flowManagementService.stopFlow(this.environment$.value, f.flowName, this.fieldIsAdmin).toPromise().then((response) => {
                f.flowState = "Stopped";
            });
        });
    }

    public testRuns() {
        // this.storageService.runs.count().then(c=>{
        //     alert(c);
        // });
        var d = new Date();

        // var p1 = this.storageService.runs.toArray();
        // var p2 = this.storageService.runs.toCollection().toArray();
        // var p3 = this.storageService.runs.toCollection().raw().toArray();
        // var p4 = this.storageService.getFlows();

        // p1.then(c => {
        //     var d1 = new Date();
        //     console.log(c.length + " " + (d.getTime() - d1.getTime()));
        // })
        // p2.then(c => {
        //     var d2 = new Date();
        //     console.log(c.length + " " + (d.getTime() - d2.getTime()));
        // });
        // p3.then(c => {
        //     var d3 = new Date();
        //     console.log(c.length + " " + (d.getTime() - d3.getTime()));
        // });
        // p4.then(c => {
        //     var d4 = new Date();
        //     console.log(c.length + " " + (d.getTime() - d4.getTime()));
        // })
    }

    public detailExpanded(event: { dataItem: Flow, index: number }) {
        var runs = event.dataItem.runs;
        var i = 0;

        //this.analytics.send("flows", "expand");
        //this.appInsights.logPageView(`flows: expand`);
        this.appInsights.trackEvent(`flows`, { "select": "expand" });

        this.flowManagementService.getFlowRuns(event.dataItem, false, true).then(runs => {
            event.dataItem.loading = false;
        });
    }

    public multiChange(values: any[], filterService: FilterService, field: string, operator: string): void {
        filterService.filter({
            filters: values.map(value => ({
                field: field,
                operator: operator,
                value
            })),
            logic: 'or'
        });
    }

    public multiFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
        return flatten(filter).map(({ value }) => value);
    }

    public async doHistory(flow:Flow) {
        var status = await this.paymentService.checkSubscription();
        if (!status) return;

        // if (!this.gridFilters.length) {
        //     this.filterBy("displayName", flow.displayName, false);
        // }

        const dialogRef = this.windowService.open({
            title: 'Version History: ' + flow.displayName,
            content: FlowVersionsComponent,
            keepContent: false,
            minHeight: 600,
            minWidth: 800,
            width: 800,
            top: 10
            // actions: [
            //     { text: 'No' },
            //     { text: 'Yes', primary: true }
            // ]
        });
        const flowComponent: FlowVersionsComponent = dialogRef.content.instance;
        flowComponent.flow = flow;
    }

    public doFailHint(flow:Flow) {


        const dialog: DialogRef = this.dialogService.open({
            title: 'High Failure Runs alert',
            content: `This Flow fails a lot`,
            actions: [
                { text: 'OK', primary: true }
            ],
            width: 450,
            height: 200,
            minWidth: 250
        });

    }

    public doRunHint(flow:Flow) {

        let name = flow.displayName;
        let trigger = flow.trigger;

        let hints = [];

        if (trigger == "SharePoint") {
            hints.push("There may be a infinite loop.  Flow updates may be triggering a new run.");
        }

        if (trigger == "Recurrence") {
            hints.push("The schedule may be too frequent.");
        }

        let content = `Flow has a very high number of runs.\r\n`;

        if (hints.length > 0) {
            content += `` + hints.map(hint => `* ${hint}`).join('');
        }

        // content += ''+
        // '<a href="mailto:support@flowstudio.app" (click)="$event.stopPropagation()" class="k-button k-primary k-outline button-logo-1"><span class="k-icon k-i-email"></span>Let us help you fix them</a>' +
        // ''


        const dialog: DialogRef = this.dialogService.open({
            title: 'High Runs alert',
            content: content,
            actions: [
                { text: 'OK', primary: true }
            ],
            width: 450,
            height: 200,
            minWidth: 250
        });

    }

    public async doExcel() {
        var status = await this.paymentService.checkSubscription();
        if (!status) return;

        this.grid.saveAsExcel();
    }

    /**
     * Route to a specific tab on the flow-view page (`/flows/:env/:name/<tab>`).
     * Used by context-menu actions ("Edit JSON", "Get Latest Runs",
     * "Flow Diagram", "Snapshots") so they navigate to a real URL the user can
     * bookmark / share, instead of opening modal dialogs.
     */
    private navigateToFlowTab(flow: Flow, tab: 'view' | 'runs' | 'snapshots' | 'json' | 'diagram'): void {
        if (!flow?.environment || !flow?.flowName) return;
        const queryParams: Record<string, string> = {};
        if (this.fieldIsAdmin) queryParams['admin'] = 'true';
        this.router.navigate(
            ['/flows', flow.environment, flow.flowName, tab],
            Object.keys(queryParams).length ? { queryParams } : {}
        );
    }

    /**
     * Toolbar "Edit JSON" handler — navigates to /json for the first selected
     * flow. Replaces the legacy dialog-tab behaviour from doEditJSON for the
     * single-selection case.
     */
    public editJsonFromToolbar(): void {
        const [first] = this.getSelectedFlows();
        if (!first) return;
        this.navigateToFlowTab(first, 'json');
    }

    /**
     * Toolbar "Flow Diagram" handler — navigates to /diagram for the first
     * selected flow. Replaces the legacy dialog from doDiagram() for the
     * single-selection case.
     */
    public diagramFromToolbar(): void {
        const [first] = this.getSelectedFlows();
        if (!first) return;
        this.navigateToFlowTab(first, 'diagram');
    }

    public async doDiagram(flow?:Flow) {

        var status = await this.paymentService.checkSubscription();
        if (!status) return;

        if (!flow) {
            [flow] = this.getSelectedFlows();
        }

        if (flow == null) {
            alert('select a flow');
            return;
        }

        // get flow definition.
        const dialog: WindowRef = this.windowService.open({
            title: 'Flow Diagram',
            content: FlowDiagramComponent,
            // actions: [
            //     { text: 'OK', primary: true }
            // ],
            width: 800,
            height: 600,
            minWidth: 250,
            resizable: true,
            keepContent: false
        });
        const flowDiagram: FlowDiagramComponent = dialog.content.instance;
        flowDiagram.flowName = flow.flowName;
    }

    public doAddOwner(flow: Flow) {
        let p = this.flowManagementService.getFlowOwners(flow, true).toPromise().then(owners => {

            // check if user already owner
            let oid = this.flowManagementService.getCurrentUser()['oid'];
            let owner = owners.find(owner => {
                return (owner['name'] == oid)
            });

            if (owner == null) {
                return this.flowManagementService.putFlowOwnerAsAdmin(flow, oid).toPromise()
                // add user to owner
            }
            else {
                return Promise.resolve();
            }
        }, (response) => {
            //this.error = response.error || response;
        });

        p.then(()=>{
            //this.refreshFlow(flow.flowName);
        })

    }

    public async restoreFlowAsAdmin(flow: Flow) {
        try {
            this.loaded = false;
            if (flow.flowState == 'Deleted') {
                await this.flowManagementService.restoreFlowAsAdmin(flow).toPromise();

                this.refreshEnvironment(this.flowManagementService.currentEnvironment);

                // this.refreshEnvironment(this.environment, true, false);
            }
        }
        finally {
            this.loaded = true;
        }
    }    

    public allData(): ExcelExportData {
        const flows = this.flows$.value;
        const result: ExcelExportData =  {
            data: process(flows, {
                sort: [{ field: 'displayName', dir: 'asc' }],
                group: []
            }).data,
            group: []
        };
        return result;
    }
    //
    // public calcSparklines$(flowName: string) {
    //     return this.runs$.pipe(
    //         map((runs)=>runs.filter((run)=>run.flowName == flowName)),
    //         map((runs)=>runs.slice(0,20)),
    //         map((runs)=>{
    //             return runs.map(run=>{
    //                 return [
    //                     run.duration,
    //                     null,
    //                     getRunColour(run.status)
    //                     //( /succeeded/gi.test(run.status) ? '#228B22' : '#C21807')
    //                 ]
    //             });
    //         })
    //     )
    // }

    /*
    public makeSolution(flow:Flow) {

        let names = [];
        if (this.selection && this.selection.length > 0) {

            names = this.flows.filter(f => {
                return this.selection.indexOf(f.flowName) != -1;
            }).map(f => {
                return f.flowName;
            });
        }
        else {
            names = [flow.flowName];
        }

        this.flowManagementService.makeFlowSolutionAware(this.flowManagementService.currentEnvironment, names, 'beb22393-dc66-e911-a97e-000d3ad1c0d2').toPromise().then(()=>{

//debugger;
        }, (reason)=>{
            alert(reason);
        });

    }
    */

    public async connectDataverse() {
        // check if we have dataverse

        // connect
        let env = await firstValueFrom(this.flowManagementService.getEnvironment(this.flowManagementService.currentEnvironment));

        //debugger;
        let dynamicsRoot = env.properties.linkedEnvironmentMetadata.instanceApiUrl;

        let token = this.msalHelperService.getCachedTokenInternal([`${dynamicsRoot}/user_impersonation`]);
        if (true || !token) {
            this.msalHelperService.loginDynamicsConsent(dynamicsRoot);
        }
    }

    public loginPowerConsent() {
        this.msalHelperService.loginPowerConsent();
    }

    public loginPowerAdmin() {
        this.msalHelperService.loginPowerAppConsent();
    }
}

export function includes(source: string = '', search: string = ''): boolean {
    return source.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
}

